import {
  computed
} from 'vue'
import { siteffix } from '@/store'
import { useStore } from 'vuex'

export default () => {
  const store = useStore()
  // 类目
  const channel = computed<number>(() => store.state.bussiness.schannel)
  const fastCates = computed<any[]>(() => store.state.bussiness.fastCates)

  const ffix = siteffix()

  const cate = computed(() => fastCates.value[channel.value].map((v: any) => ({
    value: v.value,
    label: v['cateName' + ffix]
  })))

  return cate
}
